import { Typography, styled } from "@mui/material";

export const PageTitle = styled(Typography)(({ theme }) => ({
    display: "block",
    align: "left",
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.palette.blackFont.main,
}));
